/**
 * Load the right hero image from an img tag.
 * The tag has src set, so it updates the image when src changes.
 */
export function blockHeroBgImage() {
    let bgImage = document.querySelector('.block-hero__image');
    let heroContainer = document.querySelector('.block-hero__container, .block-hero-contact__container');

    if ( heroContainer === null ) {
        return;
    }

    let bgContainer = heroContainer.querySelector('.block-background-image');
    let isSearchHero = heroContainer.classList.contains('block-hero__container--is-service-search');

    function updateBgImage() {
        let src = typeof bgImage.currentSrc !== 'undefined' ? bgImage.currentSrc : bgImage.src;

        if (bgImage.src !== src) {
            bgImage.src = src;
        }

        bgContainer.style.backgroundImage = 'url("' + bgImage.src + '")';
    }

    if (bgImage && !isSearchHero) {
        heroContainer.classList.add('block-hero__container--has-image');

        bgImage.addEventListener('load', function () {
            updateBgImage();
        });

        if (bgImage.complete) {
            updateBgImage();
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/hero-images.js